const HR = {
  ibanLength: 21,
};
export { HR };
